module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "pageWrapper",
    staticClass: "page-static ",
    class: ("page-static-" + _vm.nid)
  }, [_c('div', {
    ref: "pageTopWrapper",
    staticClass: "top-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.node.title))])]), _c('article', {
    staticClass: "node node-type-article"
  }, [_c('div', {
    ref: "pageBodyWrapper",
    staticClass: "page-body-wrapper"
  }, [_c('article', {
    staticClass: "node node-type-article"
  }, [_c('div', {
    staticClass: "article-parent-wrapper"
  }, [_c('page-body', {
    attrs: {
      "nid": _vm.nid
    }
  })], 1)])])]), _vm._m(0), _c('div', {
    staticClass: "credit-wrapper"
  }, [_c('div', {
    staticClass: "monster-head"
  }, [_c('div', {
    staticClass: "monsters"
  }, [_c('div', {
    staticClass: "monster-shadow"
  }, [_c('svg-alien-giant')], 1), _c('div', {
    staticClass: "monster-main"
  }, [_c('svg-alien-giant')], 1)])]), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "the-team"
  }, [_vm._v("THE TEAM")]), _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.authorList), function(value, index) {
    return _c('div', {
      key: "index",
      staticClass: "item"
    }, [_c('div', {
      staticClass: "alien-icon"
    }, [_c(_vm.assignAlien(index), {
      tag: "component",
      attrs: {
        "nid": _vm.nid
      }
    })], 1), _c('div', {
      staticClass: "equal"
    }, [_vm._v("=")]), _c('div', {
      staticClass: "name"
    }, [(value.tid) ? _c('term-link', {
      attrs: {
        "tid": value.tid,
        "title": value.title,
        "url": value.relative_url,
        "type": value.type
      }
    }, [_vm._v(_vm._s(value.title))]) : _vm._e()], 1), _c('div', {
      staticClass: "contacts"
    }, [_c('a', {
      class: {
        'link--default': !_vm.get(value, 'links.facebook')
      },
      attrs: {
        "href": _vm.get(value, 'links.facebook', 'javascript:void(0)'),
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "facebook contact",
      class: {
        dim: !_vm.get(value, 'links.facebook')
      }
    }, [_c(("svg-contact-fb" + (!_vm.get(value, 'links.facebook') ? '-grey' : '')), {
      tag: "component"
    })], 1)]), _c('a', {
      class: {
        'link--default': !_vm.get(value, 'links.twitter')
      },
      attrs: {
        "href": _vm.get(value, 'links.twitter', 'javascript:void(0)'),
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "twitter contact",
      class: {
        dim: !_vm.get(value, 'links.twitter')
      }
    }, [_c(("svg-contact-twitter" + (!_vm.get(value, 'links.twitter') ? '-grey' : '')), {
      tag: "component"
    })], 1)]), _c('a', {
      class: {
        'link--default': !_vm.get(value, 'links.instagram')
      },
      attrs: {
        "href": _vm.get(value, 'links.instagram', 'javascript:void(0)'),
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "instagram contact",
      class: {
        dim: !_vm.get(value, 'links.instagram')
      }
    }, [_c(("svg-contact-instagram" + (!_vm.get(value, 'links.instagram') ? '-grey' : '')), {
      tag: "component"
    })], 1)])])])
  }))])]), _c('div', {
    staticClass: "disclaimer-wrapper"
  }, [_vm._v("Abacus is a unit of the South China Morning Post Publishers Ltd.")]), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email-us-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "mailto:edt.customerserv@scmp.com"
    }
  }, [_c('div', {
    staticClass: "email-us-button"
  }, [_c('span', [_vm._v("EMAIL US")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-wrapper"
  }, [_c('div', {
    staticClass: "address__header"
  }, [_vm._v("South China Morning Post"), _c('br'), _vm._v("Publishers Ltd.")]), _c('hr'), _c('div', {
    staticClass: "address__body"
  }, [_c('div', [_vm._v("19/F., Tower 1, Times Square, 1 Matheson Street, Causeway Bay, Hong Kong")]), _c('a', {
    attrs: {
      "href": "tel:+85225658822"
    }
  }, [_vm._v("(852) 2565 8822")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7adbe1db","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/page/AboutUs.vue
// module id = 1767
// module chunks = 4